import { handleGetLaunchDateWindow } from "../helperFunctions";
import { listParam } from "./listFilters";

export const LAUNCH_DATE_SKIP_REASONS = {
  notSet: "no launch date yet",
  launchesTonight: "locked after 11 PM, they launch tonight",
  launched: "launch date has passed and they are already launched",
};

export const LAUNCH_DATE_LOCK_TITLES = {
  launchesTonight: "Locked after 11 PM, it launches tonight",
  launched: "Already launched",
};

/** True when any hook of the request is live or on its way to Meta. */
export const handleIsRequestLaunched = ({ summary }) =>
  (summary?.launched ?? 0) + (summary?.in_progress ?? 0) > 0;

/** Groups the selected requests into the ones that can move and, per reason, the ones that will be skipped. */
export const handleSplitByLaunchDateWindow = ({ ids, requests }) => {
  const byId = new Map(requests.map((r) => [r.id, r]));
  return ids.reduce(
    (acc, id) => {
      const row = byId.get(id);
      const { lockReason } = row
        ? handleGetLaunchDateWindow({
            launchDate: row.launch_date,
            launched: handleIsRequestLaunched({ summary: row.launch_summary }),
          })
        : { lockReason: null };
      acc[lockReason || "movable"].push(id);
      return acc;
    },
    { movable: [], notSet: [], launchesTonight: [], launched: [] }
  );
};

export const CHECKBOX_COL_WIDTH = 44;

export const EMPTY_PANEL_FILTERS = {
  priority: "",
  qcStatus: "",
  source: "",
  agency: "",
  requestedBy: "",
  requestedByLabels: [],
  categories: [],
};

export const panelFromUrl = (params) => ({
  ...EMPTY_PANEL_FILTERS,
  priority: params.get("priority") || "",
  qcStatus: params.get("qc_status") || "",
  source: params.get("source") || "",
  agency: params.get("agency") || "",
  requestedBy: params.get("requested_by") || "",
  categories: listParam(params.get("category")),
});

/** Last month the due-date picker can show; DatePicker stops at the current month by default. */
export const DUE_DATE_END_MONTH = new Date(
  new Date().getFullYear() + 1,
  11,
  31
);

/** Meta ad accounts; keep in step with backend ads/constants.py. */
export const ACCOUNT_OPTIONS = [
  "Seekho-GTM",
  "Seekho-BAU",
  "Arivu",
  "Bolo App",
  "Business Seekho",
  "Kali",
  "Keyaro Edutech Pvt. Ltd.",
  "Nerchuko",
  "OGCreatives",
  "Seekho- Microdrama",
  "Seekho Creative GTM",
  "Seekho Global",
  "Seekho Growth Testing",
  "Seekho Kids",
  "Seekho Tamil",
  "Seekho US",
  "Seekho-Cloning",
  "Seekho-engagement",
  "Seekho_Maino",
  "Seekho_iOS",
  "Seekhoapp",
  "Vidhya",
  "Vidya Vihar (Testing)",
  "seekho astro",
  "seekho sarkarikaam",
  "seekho sharemarket",
];

/** Yes/No choices for the Auto launch column in bulk grids and the Google Sheet. */
export const AUTO_LAUNCH_OPTIONS = ["Yes", "No"];

/** Excel columns for the Ad Request export. */
export const adRequestExportColumns = (showAgencyColumns) => [
  { header: "Request ID", value: (r) => r.id },
  {
    header: "Parent Ad ID",
    value: (r) => (r.ad_id != null && r.ad_id !== -7 ? r.ad_id : ""),
  },
  { header: "Ad name", value: (r) => r.ad_name ?? "" },
  { header: "Topic", value: (r) => r.topic ?? "" },
  { header: "Adset name", value: (r) => r.adset_name ?? "" },
  { header: "Module", value: (r) => r.module ?? "" },
  { header: "Category", value: (r) => r.category ?? "" },
  { header: "Track", value: (r) => r.track ?? "" },
  { header: "For app", value: (r) => r.for_app_name ?? "" },
  { header: "Account", value: (r) => r.account ?? "" },
  { header: "Ad type", value: (r) => r.ad_type_name ?? "" },
  { header: "Ad type ID", value: (r) => r.ad_type_id ?? "" },
  { header: "Script", value: (r) => r.script ?? "" },
  { header: "Reference link", value: (r) => r.reference_link ?? "" },
  {
    header: "Example reference link",
    value: (r) => r.example_reference_link ?? "",
  },
  { header: "Format required", value: (r) => r.format_required ?? "" },
  { header: "Due date", value: (r) => r.due_delivery_date ?? "" },
  { header: "Hooks", value: (r) => r.hooks_count ?? "" },
  { header: "Priority", value: (r) => r.priority ?? "" },
  { header: "Requested via", value: (r) => r.requested_via ?? "" },
  { header: "Status", value: (r) => r.status ?? "" },
  { header: "QC status", value: (r) => r.qc_summary ?? "" },
  {
    header: "Moderation status",
    value: (r) => r.finalized_status || r.moderation_decision || "",
  },
  { header: "Requested by", value: (r) => r.requested_by_name ?? "" },
  { header: "Requested by ID", value: (r) => r.requested_by_id ?? "" },
  ...(showAgencyColumns
    ? [
        {
          header: "Requested for agency",
          value: (r) => r.requested_for_agency_name ?? "",
        },
        {
          header: "Requested for agency ID",
          value: (r) => r.requested_for_agency_id ?? "",
        },
      ]
    : []),
  { header: "Comments", value: (r) => r.comments ?? "" },
  { header: "Created on", value: (r) => r.created_on ?? "" },
  { header: "Updated on", value: (r) => r.updated_on ?? "" },
];
